






















































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import yoy from './components/yoy.vue'
const echarts = require('echarts')
import { equipmentEnergy } from '@/api/enerySupervision'
import  NoData from '@/components/NoData'
@Component({
    components:{
        yoy,
        NoData
    }
})
export default class Login  extends Vue {
    private year:any=moment(new Date().getFullYear(), 'YYYY')
    private month:any='00'
    private yearShowOne:boolean=false
    private tiemDefaultValue:string='全年'
    private timeArr:any[]=[
        {value:'全年',id:`00`},
        {value:'一月',id:`01`},
        {value:'二月',id:`02`},
        {value:'三月',id:`03`},
        {value:'四月',id:`04`},
        {value:'五月',id:`05`},
        {value:'六月',id:`06`},
        {value:'七月',id:`07`},
        {value:'八月',id:`08`},
        {value:'九月',id:`09`},
        {value:'十月',id:`10`},
        {value:'十一月',id:`11`},
        {value:'十二月',id:`12`},
    ]
    private dataList:any=null
    private unitType:number=0
    private action:string='view'
    private code:any=null
    private riseObj:any={
        aboveNumber:0,
        belowNumber:0,
        rise:0,
        riseRate:0,
        aboveDate:0,
        belowDate:0,
    }
    // 弹出日历和关闭日历的回调
    openChangeOne(status:any){
        if(status){
            this.yearShowOne =  true
        }else{
            this.yearShowOne =  false
        }
    }
    // 选择月份
    handleChange(value:any) {
        this.month=value
        if(moment(this.year).format('YYYY')=='Invalid date'){
            this.$message.error('年份不能为空')
        }else if(value=='00'){
            this.riseObj.aboveDate=`${moment(this.year).format('YYYY')}`
             this.riseObj.belowDate= `${Number(moment(this.year).format('YYYY'))-1}`
            const params={
                enterpriseCode:this.code,
                statDate: this.riseObj.aboveDate,
            }
            this.init(params)
        }else{
            this.riseObj.aboveDate=`${moment(this.year).format('YYYY')}-${value}`
              this.riseObj.belowDate= `${Number(moment(this.year).format('YYYY'))-1}-${value}`
            const params={
                enterpriseCode:this.code,
                statDate: this.riseObj.aboveDate,
            }
            this.init(params)
        }

    }
    // 得到年份选择器的值
    onYearChange(value:any){
        this.year = moment(value).format('YYYY')
        if(this.month=='00'){
            this.riseObj.aboveDate=this.year
             this.riseObj.belowDate=String(this.year-1)
        }else{
            this.riseObj.aboveDate=`${this.year}-${this.month}`
            this.riseObj.belowDate=`${this.year-1}-${this.month}`
        }
        const params={
            enterpriseCode:this.code,
            statDate: this.riseObj.aboveDate,
        }
        this.init(params)
        this.yearShowOne = false
        // this.getUtilizationList(this.$route.query.encode,this.year)
    }
    init(params:any){
        this.getCquipmentEnergy(params)
        // this.getCompanyInfo(params.enterpriseCode)
    }
    async getCquipmentEnergy(params:any){
        this.dataList = []
        const {status,data}=await equipmentEnergy(params)
        if(status==0&&data){
            data.forEach((ele:any)=>{
                if(params.statDate&&params.statDate.length!==4){
                    ele['aboveDate']=this.riseObj.aboveDate
                    ele['belowDate']=this.riseObj.belowDate
                }else{
                    ele['aboveDate']=this.riseObj.aboveDate
                    ele['belowDate']=String(this.riseObj.aboveDate-1)
                }
            })
            this.dataList=data
            const that=this
            setTimeout(function(){
                that.handleEharts()
            },300)
        
        }
    }
    handleEharts(){
        this.dataList.forEach((ele:any,index:number) => {
            const dataX:any=[]
            const dataY:any=[]
            ele.outputList.forEach((out:any) => {
            dataX.push(out.statData)
            dataY.push(out.dataValue)
            })
            this.initConsumption(dataX,dataY,index)
        })
    }
     //综合消耗走势图
    initConsumption(dataX:any,dataY:any,id:number) {
        const main:any = document.getElementById('consumptionEchart'+id)
            main.removeAttribute('_echarts_instance_')
        if(dataY.length === 0) {
            main.innerHTML = ''
        }
        // 基于准备好的dom，初始化echarts实例
        const consumptionEchart:any = echarts.init(main as HTMLDivElement)
        // 指定图表的配置项和数据
        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                type: 'none',
                crossStyle: {
                    color: '#999',
                    fontSize:12
                }
                }
            },
            grid: {
                            left: '20',
                            top: '50',
                            right: '20',
                            bottom: '0',
                            containLabel: true
                        },
            xAxis: [{
                gridIndex: 0,
                type: 'category',
                data: dataX,
                axisPointer: {
                type: 'shadow'
                },
                axisLine:{
                lineStyle:{
                    color:'#ededff',
                    width:1
                }
                },
                axisTick:{
                show:false
                },
                axisLabel: {
                color: '#999',
                fontSize: 12
                },
            }],
            yAxis: [{
                gridIndex: 0,
                type: 'value',
                min: 0,
                axisLine:{
                lineStyle:{
                    color:'#ededff',
                    width:1
                }
                },
                axisTick:{
                show:false
                },
                axisLabel: {
                color: '#999',
                fontSize: 12,
                formatter: '{value}'
                },
            }],
            series: [{
                name: '主要产品产量',
                type: 'bar',
                barWidth : 20,//柱图宽度
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 1, color: '#d2e8fe'},                   //柱图渐变色
                                {offset: 0.5, color: '#7ebcfd'},                 //柱图渐变色
                                {offset: 0, color: '#3596fb'},                   //柱图渐变色
                            ]
                        ),
                        label:{
                            fontSize:9,
                            show:false,
                            position: 'top'
                        }
                    }
                },   
                data: dataY
            }]
            }
        // 使用刚指定的配置项和数据显示图表。
        consumptionEchart.setOption(option)
    }
    created(){
        if(this.$route.query.encode){
        this.code=this.$route.query.encode.toString()
        this.action=this.$route.query.action.toString()
        this.riseObj.aboveDate= this.$route.query.year
        this.riseObj.belowDate=String(this.riseObj.aboveDate-1) 
        const params={
            enterpriseCode: this.code,
            statDate: this.riseObj.aboveDate,
            unitType:this.unitType
        }
        this.init(params)
        }
    }
}
